import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=16684565&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=ts&"
export * from "./Welcome.vue?vue&type=script&lang=ts&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=16684565&prod&lang=scss&scoped=true&"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=16684565&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16684565",
  null
  
)

export default component.exports